<div class="h-100 d-flex flex-column">
  <!-- pages title -->
  <mat-toolbar class="sidemenu-toolbar" [ngClass]=" showPageDetails ? 'gap-0' : 'gap-1'">
    <button mat-icon-button class="example-icon" (click)="navigateBackToPages()" *ngIf="showPageDetails"> 
      <mat-icon>arrow_back</mat-icon>
    </button>
    <i class="icon mdi mdi-window-restore" *ngIf="!showPageDetails"></i>
    <span class="title" >{{(showPageDetails ? selectedPageName :'Pages') | titlecase}}</span>
  </mat-toolbar>
  <div #pagesContainer [hidden]="showPageDetails">

  </div>
  <!-- @if(!showPageDetails){ -->
  <div *ngIf="activeSpinner && copyPageInProgress || isDeleteInProcess" [class.imageCenter]="activeSpinner && copyPageInProgress || isDeleteInProcess" >
  <mat-spinner diameter="30"></mat-spinner>  
  </div>
  <!-- pages  -->
  <mat-list #pagesContainer [hidden]="showPageDetails" class="mat-list-custom flex-fill overflow-auto drag-boundary drag-drop-container"
        *ngIf="pagesdata && pagesdata.length > 0"
        [class.screenblur]="activeSpinner || isDeleteInProcess"
        cdkDropList 
        [cdkDropListAutoScrollStep]="15"
        [cdkDropListData]="pagesdata" 
        (cdkDropListDropped)="drop($event)"
        cdkDropListOrientation="vertical"
        [cdkDropListDisabled]="widgetDragActive" >

    @for(page of pagesdata; track trackByPageId(pageIndex,page); let pageIndex = $index) {
      <div cdkDrag  id="page-{{page.pageId}}"  class="drag-wrapper"   (cdkDragStarted)="onPageDragStarted()"   (cdkDragReleased)="onPageDragReleased()" [cdkDragDisabled]="widgetDragActive || invalidPageTypes.includes(page?.pageType?.trim()) || page['open']" cdkDragBoundary=".drag-boundary" observeVisibility (visibleChange)="onPageVisibilityChange(page?.pageId, $event)" >
        <!-- drag placeholder -->
        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
        <mat-list-item class="px-0 mat-list-item" mat-ripple >
          <!-- header page name -->
           <span #spanHover></span>
          <div  class="item-fill px-1 d-flex"  mat-ripple
          (click)="pageDetailsSetter(page)"(mouseenter)="spanHover.hidden= true" (mouseleave)="spanHover.hidden= false" >
          
              <!-- <div  class=" me-0 ps-1" [ngClass]="spanHover.hidden ? 'w-50' : 'w-100'"> -->
                <div class=" flex-fill px-2"  [ngClass]="spanHover.hidden ? 'w-50' : 'w-90'"> 
                  <mat-icon ><i class="icon mdi mdi-window-maximize"></i></mat-icon><span class="mat-panel-title-inner d-inline-block text-ellipsis  vertical-align-text-bottom ps-1"  >{{ page.pageName | titlecase  }}</span></div>
              <!-- page actions -->
              <div  class="item-end control-buttons" *ngIf="page.pageType?.trim() !== 'PreviewPage'">
                @if(!pagesSheffelInProcess && !widgetDragActive){
                <ng-container *ngIf="page && page.pageType && !excludedPageTypes.includes(page.pageType)">
                  <!-- edit -->
                  <button mat-icon-button
                    (click)="$event.stopPropagation();addPage(addPagePopUp,'edit',page.pageId,page.pageName)"
                    *ngIf="[appPermissions.editPage,permissionsActions.edit] | builderPermissions">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <!-- copy page -->
                    @if(page.pageType?.trim() === this.pageTypes.customPage){
                      <button mat-icon-button [disabled]="copyPageInProgress" (click)="$event.stopPropagation();copyPage(page.pageId)"
                        *ngIf="[appPermissions.copyPage,permissionsActions.edit] | builderPermissions">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                    }
                  <!-- delete page -->
                  <button mat-icon-button color="warn"
                    (click)="$event.stopPropagation();deletePage(page?.pageId,deletePageErrorPopUp,page.pageName,'False')"
                    *ngIf="[appPermissions.deletePage,permissionsActions.edit] | builderPermissions" [disabled]="isDeleteInProcess">
                    <mat-icon>delete</mat-icon>
                  </button>
                </ng-container>
                }
              </div>
          </div>
        </mat-list-item>
      </div>
    }

  </mat-list>


  <!-- Add Page button -->
  <div class="p-2" [hidden]="showPageDetails">
  <button mat-stroked-button color="primary" class="add-button w-100" (click)="addPage(addPagePopUp,'add')"  *ngIf="[appPermissions.addPage,permissionsActions.edit] | builderPermissions" ><mat-icon>add</mat-icon> Add
  Page</button>
  </div>
   @if(showPageDetails){
     <lib-page [page]="selectedPage" [pageIndex]="pageIndex" [pageLoading]="pageLoading"></lib-page>
   }
  
</div>

<!-- Add page popup -->
<ng-template #addPagePopUp >
  <div (keydown.escape)="closeTemplate()" (keydown.enter)="savePage()" (click)="onMouseClick()" [class.screenblur]="activeSpinner">
  <mat-dialog-content class="add-page-dailog">
  <div class="row">
    <div class="col-12" [formGroup] = "addPageForm">
      <h2>
      <span *ngIf="!editPage">Add Page</span>
      <span *ngIf="editPage">Edit Page</span>
      </h2>     
      <mat-form-field class="w-100" appearance="outline" [color]="((isPageNameExist) || isPagenameEmpty) ? 'warn':'primary'">
        <mat-label>Page Name</mat-label>
        <input matInput placeholder="Page Name" formControlName="name" [errorStateMatcher]="matInputError" (input)="onPageNameAdd($event,editPage)"/>
        <mat-hint  [ngClass]="isPageNameExist ? 'error-message' : 'text-success'" *ngIf="addPageForm.get('name')?.value && addPageForm.get('name')?.value.length > 2 && getNameErrorMessage(addPageForm.get('name')) == ''">{{pageNameCheck}}</mat-hint>
        <mat-error class="error-message" *ngIf="addPageForm.invalid">{{ getNameErrorMessage(addPageForm.get('name')) }}</mat-error>
      </mat-form-field>
      <ng-container>
        <mat-label>Map above Page To Entity</mat-label>
        <div [formGroup]="entityForm">
          <ng-container *ngIf="entityFormEdit">
            <mat-radio-group aria-label="Select an option" formControlName="selection">
              <mat-radio-button value="existing">Select from existing</mat-radio-button>
              <mat-radio-button value="new">Create new entity</mat-radio-button>
            </mat-radio-group>
            <mat-form-field class="w-100" appearance="outline" *ngIf="entityForm.get('selection')?.value == 'new'">
              <mat-label>Entity Name</mat-label>
              <input matInput placeholder="Entity Name"  formControlName="name" [errorStateMatcher]="matInputError"/>
              <mat-hint  [ngClass]="isEntityNameExists ? 'error-message' : 'text-success'" *ngIf="entityForm.get('name')?.value && entityForm.get('name')?.value.length > 2 && getNameErrorMessage(entityForm.get('name')) == ''">{{entityNameCheck}}</mat-hint>
              <mat-hint class="error-message">{{ getNameErrorMessage(entityForm.get('name')) }}</mat-hint>
            </mat-form-field>
          </ng-container>
          <mat-form-field class="w-100" *ngIf="entityForm.get('selection')?.value != 'new'" appearance="outline">
            <mat-label>Entitys</mat-label>
            <mat-select matNativeControl formControlName="dropDownData"  placeholder="Select Entity" searchable [isObjectsList]="true" [displayKey]="'entity_name'">
              <ng-container *ngFor="let item of entityData">
                <mat-option [value]='item?.entity_id'>{{item?.entity_name}}</mat-option>
              </ng-container>
            </mat-select>
            <mat-icon matSuffix color="warn" *ngIf="entityForm.get('dropDownData')?.value != null" (click)="entityForm.get('dropDownData')?.reset()">clear</mat-icon>
            <mat-hint class="error-message" *ngIf="entityData?.length==0">Entity not found. Please create an entity first</mat-hint>
          </mat-form-field>
        </div>
      </ng-container>
  </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dailog-footer-buttons">
  <button mat-button (click)="closeTemplate()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="addPageForm.invalid || entityForm.invalid || (isPageNameExist) || !isFormChanged " (click)="savePage()">Save</button>
</mat-dialog-actions>
</div>
<div *ngIf="activeSpinner" [class.imageCenter]="activeSpinner">
  <mat-spinner diameter="30"></mat-spinner>  
</div>
</ng-template>

<!-- Delete page popup -->
<ng-template #deletePageErrorPopUp>
  <div (keydown.escape)="closeTemplate()">
    @if(pageDeleteMessage?.pageName) {
       <div mat-dialog-title><mat-icon class="position-Icon warning-color">warning</mat-icon><span class="title warning-color">
          Delete "{{(errorPage | titlecase) || 'Page'}}" Page</span></div>
      <mat-dialog-content class="add-page-dailog">
        @if( pageDeleteMessage.linked_pages && pageDeleteMessage.linked_pages.length > 0) {
          <p>This page is referenced by widgets in the following page{{ pageDeleteMessage.linked_pages.length > 1 ? 's' : '' }}: </p>
       
          <table class="link-table">
            <thead>
              <tr>
                <th>Page</th>
                <th>Widget</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let page of pageDeleteMessage.linked_pages">
                <ng-container *ngFor="let widget of page.widgets; let i = index">
                  <tr>
                    <td *ngIf="i === 0" [attr.rowspan]="page.widgets.length">{{ page.page }}</td>
                    <td>{{ widget.widgetName }}</td>
                    <td>{{ widget.link | titlecase }}</td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        }


        <p *ngIf="pageDeleteMessage.linked_entities" style="margin-top: 1em;">
          <span *ngIf="pageDeleteMessage.linked_pages && pageDeleteMessage.linked_pages.length > 0">Additionally ,</span> This
          page is linked to the following {{ pageDeleteMessage.linked_entities.length > 1 ? 'entities' : 'entity' }}:
          <strong>{{ pageDeleteMessage.linked_entities.join(', ') }}</strong>.
        </p>
        <p class="fw-500 fs-medium">
          Deleting this page will impact the <span
            *ngIf="pageDeleteMessage.linked_pages && pageDeleteMessage.linked_pages.length > 0"> above page{{
            pageDeleteMessage.linked_pages.length > 1 ? 's' : '' }} and could break associated widget actions and</span> entity.
        </p>
      </mat-dialog-content>
    }@else {
      <div mat-dialog-title><mat-icon class="position-Icon warning-color">warning</mat-icon><span class="title warning-color">
          Delete "{{errorPage || 'Page'}}" Page</span></div>
      <mat-dialog-content class="add-page-dailog">
        <p>Are you sure you want to delete this page?</p>
    
      </mat-dialog-content>
    }
    <mat-dialog-actions class="dailog-footer-buttons">
      <button mat-button (click)="closeTemplate()">Cancel</button>
      <button mat-raised-button color="warn" (click)="deletingPage(page_id,'True'); this.closeTemplate()">Delete</button>
    </mat-dialog-actions>
  </div>
</ng-template>




